import {
  BackInStockProductSchema,
  ProductNotificationGroupBy,
  ProductNotificationStatus,
} from "@redotech/redo-model/customer-product-notification/customer-product-notification";
import { MarketingChannel } from "@redotech/redo-model/marketing";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getBackInStockProducts = {
  name: "getBackInStockProducts" as const,
  input: z.object({
    searchQuery: z.string().optional(),
    limit: z.number().int().positive().max(200).default(50),
    groupBy: createEnum(ProductNotificationGroupBy).default(
      ProductNotificationGroupBy.VARIANT,
    ),
    dateFrom: z.date().optional(),
    dateTo: z.date().optional(),
    channels: z.array(createEnum(MarketingChannel)).optional(),
    statuses: z.array(createEnum(ProductNotificationStatus)).optional(),
  }),
  output: z.object({
    products: z.array(BackInStockProductSchema),
    totalCount: z.number(),
  }),
};
